import { styled } from 'styled-components';

export const Wrapper = styled.p`
  font-size: 1rem;
  font-weight: 700;
  align-self: center;
  margin: 0 2rem 0;
`;
